module.exports = __webpack_public_path__ + "img/undraw_Online_shopping_re_k1sv.0403f003.svg";